<div class="account-dialog">
    <div class="seperator"></div>
    <div class="title" mat-dialog-title>You're all set!</div>
    <div class="dialog-body emailsent-body">
        <div>You can now set up your first campaign and start tracking its progress.</div>
        <div class="text-gap">If you need to contact us with any issues or feature requests, you can use the Help page in the sidebar.</div>
        <mat-dialog-actions align="center">
            <button mat-raised-button mat-dialog-close class="rubii-btn gotocmp-button" color="primary">Create a new campaign</button>
        </mat-dialog-actions>
    </div>
</div>